import type { ContentRepository } from '@/data/repositories/types'
import contentData from '@/data/fixtures/content.json'
import type { ContentSubmission, SparkCode } from '@/modules/content/types'
import { aliasClient } from './demo-client'

export function createMockContentRepository(): ContentRepository {
  const submissions = contentData.contentSubmissions as ContentSubmission[]
  const sparkCodes = contentData.sparkCodes as SparkCode[]
  return {
    async getContentSubmissions(clientId: string): Promise<ContentSubmission[]> {
      const aliased = aliasClient(clientId, submissions)
      return submissions.filter((c) => c.clientId === aliased)
    },
    async getSparkCodes(clientId: string): Promise<SparkCode[]> {
      const aliased = aliasClient(clientId, sparkCodes)
      return sparkCodes.filter((c) => c.clientId === aliased)
    },
  }
}

export const contentRepository = createMockContentRepository()
